import { theme } from "../../../App";
const styles = () => ({
  container: {
    display: "flex",
    height: 60,
    width: "80%",
    margin: "0 auto",
    borderTop: `1px solid #dadce0`,
  },
  footerContent: {
    //display: "flex",
    //flexDirection: 'column',
    //flex: 1,
    color: "#333333",
    fontSize: 13,
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      flexDirection: "row",
      flex: 1,
    },
  },
  footerCopyrightLinks: {
    textDecoration: "none",
    color: "#333333",
    marginLeft: 14,
    fontSize: 13,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 24,
    },
  },
  footerLinksPrivacy: {
    cursor: "pointer",
    textDecoration: "none",
    color: "#333333",
    float: "right",
    "&:hover": {
      textDecoration: "none",
      fontWeight: "700",
      backgroundColor: "none",
    },
    paddingRight: "6px",
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3px",
      marginRight: "18px",
    },
  },
  footerLinksPrivacyLink: {
    cursor: "pointer",
    textDecoration: "none",
    color: "#333333",
    "&:hover": {
      textDecoration: "none",
      color: "#000000",
    },
    padding: "6px 16px",
    width: "100%",
  },
  footerRightDiv: {
    marginLeft: "auto",
    marginRight: "0px",
    display: "flex",
    alignItems: "center",
    paddingTop: "6px",
    //marginTop: "0px",
  },
  footerLinksPrivacyy: {
    cursor: "pointer",
    textDecoration: "none",
    color: "#333333",
    float: "right",
    "&:hover": {
      textDecoration: "none",
      fontWeight: "700",
    },
    fontSize: "12px",
  },
  footerLinksTerms: {
    cursor: "pointer",
    textDecoration: "none",
    color: "#333333",
    margin: "0px",
    textTransform: "none",
    padding: 0,
    fontSize: 13,
    "&:hover": {
      textDecoration: "none",
      fontWeight: "700",
      backgroundColor: "none",
    },
    paddingRight: "12px",
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3px",
      marginRight: "18px",
    },
  },
  privacyButton: {
    backgroundColor: "none",
    color: "#333333",
  },
  footerLabel: {
    fontSize: "13px",
    cursor: "pointer",
    paddingTop: "1px",
    textTransform: "none",
  },
  footerLogo: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
    },
  },
});

export default styles;
